import Mock from 'mockjs';
import { builder } from '../builder';
const generatorDynamicRouter = () => {
	return builder([
		{
			name: '首页',
			path: 'home',
			component: 'home',
			id: 1,
		},
		{
			name: '走进客维',
			path: 'about',
			redirect: '/about/introduction',
			component: 'about',
			id: 2,
			children: [
				{
					name: '公司简介',
					path: 'introduction',
					component: 'about',
					id: 21,
				},
				{
					name: '公司资质',
					path: 'qualifications',
					component: 'about',
					id: 22,
				},
				{ name: '公司荣誉', path: 'honor', component: 'about', id: 23 },
				{
					name: '企业文化',
					path: 'sustainability',
					component: 'about',
					id: 24,
				},
				{
					name: '公司愿景',
					path: 'vision',
					component: 'about',
					id: 25,
				},
				{
					name: '发展历史',
					path: 'history',
					component: 'about',
					id: 26,
				},
				{
					name: '公益事业',
					path: 'volunteers',
					component: 'about',
					id: 27,
				},
			],
		},
		{
			name: '业务概况',
			path: 'business',
			// component: 'business',
			component: 'news',
			id: 3,
			children: [
				{
					name: '公司简介',
					path: 'introduction',
					component: 'news',
					id: 31,
				},
				{
					name: '公司资质',
					path: 'qualifications',
					component: 'business',
					id: 32,
				},
				{
					name: '公司荣誉',
					path: 'honor',
					component: 'business',
					id: 33,
				},
			],
		},
		{
			name: '智能科技',
			path: 'technology',
			// component: 'technology',
			component: 'news',
			id: 4,
		},
		{
			name: '品牌案例',
			path: 'brand',
			// component: 'brand',
			component: 'news',
			id: 5,
		},
		{
			name: '加入客维',
			path: 'joinKewei',
			component: 'joinKewei',
			id: 6,
			children: [
				{
					name: '人才招聘',
					path: 'recruitment',
					component: 'news',
					id: 61,
				},
			],
		},
		{
			name: '新闻中心',
			path: 'news',
			component: 'news',
			id: 7,
			children: [
				{
					name: '业务视频',
					path: 'newsvideo',
					component: 'news',
					id: 71,
					children: [
						{
							name: '视频分类1',
							path: 'video1',
							component: 'news',
							id: 711,
						},
						{
							name: '视频分类2',
							path: 'video2',
							component: 'news',
							id: 712,
						},
						{
							name: '视频分类3',
							path: 'video3',
							component: 'news',
							id: 713,
							children: [
								{
									name: '视频分类1',
									path: 'video1',
									component: 'news',
									id: 711,
								},
								{
									name: '视频分类2',
									path: 'video2',
									component: 'news',
									id: 712,
								},
								{
									name: '视频分类3',
									path: 'video3',
									component: 'news',
									id: 713,
								},
							],
						},
					],
				},
				{
					name: '公司动态',
					path: 'companynews',
					component: 'news',
					id: 72,
				},
			],
		},
	]);
};

const getFooter = () => {
	return builder({
		content:
			'Copyright @2022 客维智能科技（广州）有限公司 版权所有  粤ICP备11053761号-6',
		address: '广东省广州市天河区珠江新城临江大道5号保利中心6楼',
		phone: '4006-088-183',
	});
};

Mock.mock('/api/get-head-route', 'get', generatorDynamicRouter);
Mock.mock('/api/get-footer', 'get', getFooter);
// Mock.mock('/api', 'get', () => {
//   return 'hello my life'
// })
